import * as MediaActionType from './constants';
// import * as CommonActionType from '../Common/constants';

const MediaState = {
  MediaList: [],
  MediaProfile: {},
  MediaCategories: [],
  ProjectList: [],
  ProjectListUpdated: false,
  CheckCopiedProject: {},
  ListCheckCopiedRegion: []
};

export default function MediaLibraryStore(state = MediaState, action) {
  switch (action.type) {
    case MediaActionType.GET_LIST_MEDIA_SUCCESS:

      return {
        ...state,
        MediaList: action.data.items
      };
    case MediaActionType.ADD_MEDIA_SUCCESS:
      return processAddMediaSuccess(state, action);
    case MediaActionType.GET_MEDIA_BY_ID_SUCCESS:
      return processGetMediaByIdSuccess(state, action);
    case MediaActionType.UPDATE_MEDIA_BY_ID_SUCCESS:
      return processUpdateMediaById(state, action);
    case MediaActionType.GET_MEDIA_BY_CATEGORIES_SUCCESS:
      return processGetMediaCategories(state, action);
    case MediaActionType.GET_PROJECT_LIST_SUCCESS:
      return processGetProjectListSuccess(state, action);
    case MediaActionType.CHECK_COPY_MEDIA_SUCCESS:
      return processCheckCopyMediaSuccess(state, action);
    case MediaActionType.CHECK_COPY_MEDIA_BY_REGION_SUCCESS:
      return processCheckCopyMediabyRegionSuccess(state, action);
    default:
      return state;
  }
}

// define reducer

const processAddMediaSuccess = (state, action) => {
  return {
    ...state,
    MediaProfile: action.data
  };
};

const processGetProjectListSuccess = (state, action) => {
  return {
    ...state,
    ProjectList: action.data,
    ProjectListUpdated: true
  };
};

const processGetMediaByIdSuccess = (state, action) => {
  return {
    ...state
  };
};

const processUpdateMediaById = (state, action) => {
  return {
    ...state
  };
};

const processGetMediaCategories = (state, action) => {
  return {
    ...state,
    MediaCategories: action.data
  };
};

const processCheckCopyMediaSuccess = (state, action) => {
  return {
    ...state,
    ListCheckCopiedRegion: [...state.ListCheckCopiedRegion, {
      projectId: action.data.projectId,
      copied: action.data.copied
    }]
  };
};

const processCheckCopyMediabyRegionSuccess = (state, action) => {
  return {
    ...state,
    ListCheckCopiedRegion: action.data
  };
};



// WEBPACK FOOTER //
// ./src/MediaLibrary/reducers.js